export const sessionStorageProxy = {
    getItem(key) {
        return sessionStorage.getItem(key);
    },
    hasItem(key) {
        return !!sessionStorage.getItem(key);
    },
    setItem(key, value) {
        sessionStorage.setItem(key, value);
    },
    removeItem(key) {
        sessionStorage.removeItem(key);
    },
    setObjectItem(key, value) {
        const parsed = JSON.stringify(value);
        sessionStorage.setItem(key, parsed);
    },
    getObjectItem(key) {
        const stringifiedData = sessionStorageProxy.getItem(key);
        if (stringifiedData) {
            return JSON.parse(stringifiedData);
        }
        return null;
    },
};
